import React, { FunctionComponent } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";

import AccountPasswordSettings from "./account/password/AccountPasswordSettings";
import { useUserData } from "../../hooks/useUserData";
import { useAuthentication } from "../../hooks/useAuthentication";
import { FormSettings } from "./formadmin/FormSettings";
import AccountEmailSettings from "./account/email/AccountEmailSettings";
import { ContentLayout } from "../common/Layout";
import UserProfileSettings from "./account/profile/UserProfileSettings";
import { useUserIdParam } from "../../hooks/useUserIdParam";

interface Props {
  isAuthenticated: boolean;
  isAdmin: boolean;
}

export const Settings: FunctionComponent<Props> = ({ isAuthenticated, isAdmin }) => {
  const userId = useUserIdParam();
  const [userData, isLoading, isError] = useUserData(userId);
  useAuthentication(isAuthenticated);

  if (isError) return <p>Fehler beim Laden der Daten</p>;
  return (
    <ContentLayout title={"Einstellungen"} siteTitle={"Spielgruppe Online - Einstellungen"} isLoading={isLoading}>
      <Row className={"py-5"}>
        <Col>
          <Tabs defaultActiveKey="default" id="uncontrolled-tab-example" className="mb-5">
            <Tab eventKey={"default"} title="Profil">
              <UserProfileSettings userId={userId} />
            </Tab>
            <Tab eventKey="account-password" title={"Passwort"}>
              <AccountPasswordSettings userId={userId} />
            </Tab>
            <Tab eventKey="account-email" title="E-Mail">
              <AccountEmailSettings userId={userId} />
            </Tab>

            {isAdmin && (
              <Tab eventKey="form" title="Formular (admin)">
                <FormSettings userId={userId} formSettings={userData?.settings?.formSettings} />
              </Tab>
            )}
          </Tabs>
        </Col>
      </Row>
    </ContentLayout>
  );
};
